import { ArrowRight } from "lucide-react";
import { openBooking } from "./openBooking";

export function Concept() {
  return (
    <section className="py-20 md:py-28 bg-cream">
      <div className="container-prose">
        <div className="max-w-3xl">
          <span className="eyebrow">From concept to completion</span>
          <h2 className="mt-3 font-display text-3xl md:text-5xl text-foreground leading-tight">
            Turn your concept into a reality.
          </h2>
          <p className="mt-6 text-muted-foreground text-lg leading-relaxed">
            RKD Tile brings your dream concepts to perfect completion — from idea development and design
            to an artistically stunning creation. Our team is committed to delivering the highest quality
            products and workmanship, culminating in your dream home or signature project.
          </p>
          <p className="mt-4 font-display text-2xl text-primary italic">
            If you can imagine it, we can create it.
          </p>
          <button
            type="button"
            onClick={openBooking}
            className="mt-10 inline-flex items-center gap-2 bg-primary text-primary-foreground px-7 py-4 text-sm font-semibold uppercase tracking-wider hover:bg-primary/90 transition-colors"
          >
            Schedule a Consultation <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
